import React from "react";
import { _ReportCampaigns } from "../../components/reports/admin/campaigns";
const ReportCampaigns = () => {
  return (
    <div>
      <h2>Reporte de Campañas Externas</h2>
      <_ReportCampaigns />
    </div>
  );
};

export default ReportCampaigns;
